import { ModalConfig, modalContent, modalHeading } from './modal.model';

export function getEducatorDuplicateDocumentModalConfig(): ModalConfig {
  return {
    heading: modalHeading.educatorDuplicateDocumentDetected,
    modalContent: modalContent.educatorDuplicateDocumentBody,
    hasDropdown: false,
    hasTemplate: true,
    align: true,
    headingAlign: 'left',
    panelClass: 'cancelUploadModal',
    buttons: [
      { text: 'Proceed & Upload', code: 'Y' },
      { text: 'Cancel', code: 'N', btnOutline: true }
    ]
  };
}

export function isEducatorDuplicateDocumentProceed(result: unknown): boolean {
  if (result == null || typeof result !== 'object') {
    return false;
  }
  const r = result as { code?: string };
  return r.code === 'Y';
}
